import { createAction, props } from '@ngrx/store';

export const increment = createAction('[Form-Pager Component] Increment');
export const decrement = createAction('[Form-Pager Component] Decrement');
export const setPage = createAction('[Form-Pager Component] Set Page', props<{ page: number }>());
export const setNumberOfPages = createAction('[Form-Pager Component] Set Number Of Pages', props<{ num: number }>());
export const setPageVisibility = createAction(
  '[Form-Pager Component] Set Page Visibility',
  props<{ pageVisibility: boolean[] }>()
);
export const reset = createAction('[Form-Pager Component] Reset');
export const setPageError = createAction(
  '[Page-Error] new error',
  props<{ pageHasError: boolean; displayError: boolean; errorMessage: string; questionsWithErrors: string[] }>()
);
// export const resetPageError = createAction
export const closeEndPage = createAction('[Form-Pager Component] Close End Page');
